
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class GuildRuleModal extends Vue {
  visible: boolean = false

  content: string[] = [
    '1、我们是志趣相投的桐好集体，可相约看展、出游、参与线下雅集，让线上交流丰富线下生活。待人友善谦逊，表达观点互相尊重、包容差异；只为滋养自己、发现生活之美，向内踏实成长。',
    '2、若在学习、活动、相处中有困惑可联系分桐负责人沟通解决。',
    '3、桐学会内分享的资料、内容与创作，请勿用于商业推广、售卖、引流等用途。',
    '4、尊重每位桐好隐私，不随意泄露个人信息；未经当事人同意，不私自截图、转发桐学会内的交流记录与分享内容，相处有分寸、有边界。',
    '5、交流中不谈论政治、宗教等敏感话题，不传播谣言、不发表偏激言论，共同维护温和、正向、纯粹的氛围。',
    '6、桐学会交流场景仅用于日常笔墨分享、活动通知与生活交流。课程咨询、课业答疑，请以暄桐官方公众号及官方客服渠道为准。',
    '7、如需更换所在分会，请先在官网提交“退出桐学会”申请，并及时联系分桐负责人说明情况，以便顺利调整。',
    '愿我们以笔墨为伴，以生活为诗，好好写字、好好读书、好好生活，彼此温柔相伴，收获从容丰盈的生活之美。'
  ]

  show() {
    this.visible = true
  }

  hide() {
    this.visible = false
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
